import React, { ReactNode, useRef, useEffect, useState } from 'react';
import { TableBody } from '@leadsnavi/ui-kit';
import { Table } from '@leadsnavi/ui-kit';

interface FixedHeaderTableProps {
  header: ReactNode;
  children: ReactNode;
  className?: string;
}

export const FixedHeaderTable: React.FC<FixedHeaderTableProps> = ({ header, children, className = '' }) => {
  const headerRef = useRef<HTMLDivElement>(null);
  const [headerHeight, setHeaderHeight] = useState(48); // 默认最小高度

  // 监听表头高度变化
  useEffect(() => {
    if (headerRef.current) {
      const updateHeaderHeight = () => {
        setHeaderHeight(headerRef.current!.offsetHeight);
      };

      // 初始计算
      updateHeaderHeight();

      // 监听窗口大小变化
      window.addEventListener('resize', updateHeaderHeight);

      // 清理
      return () => {
        window.removeEventListener('resize', updateHeaderHeight);
      };
    }
  }, [header]);

  return (
    <div className={`relative h-full ${className}`}>
      {/* 表头部分 - 固定 */}
      <div ref={headerRef} className=" overflow-hidden">
        <Table className="w-full border-none">{header}</Table>
      </div>

      {/* 内容部分 - 滚动 */}
      <div
        className="absolute bottom-0 left-0 right-0  overflow-y-auto overflow-x-hidden"
        style={{ top: `${headerHeight}px` }}
      >
        <Table className="w-full border-none  table-fixed   overflow-hidden">
          <TableBody>{children}</TableBody>
        </Table>
      </div>
    </div>
  );
};
